export default __webpack_public_path__ + "static/media/BP1JPG-min.cdae7c32.jpg";